export const DriveUserActionType = {
  LIST_OBJECTS: 'actions/drive/objects/LIST',
  READ_OBJECTS: 'actions/drive/objects/READ',
  WRITE_OBJECTS: 'actions/drive/objects/WRITE',
  DELETE_OBJECTS: 'actions/drive/objects/DELETE',
};
